import React from 'react';
import clsx from 'clsx';
import { useHistory } from 'react-router';

import { useIsMobile } from '../../hooks';
import { FinishedModal } from '../../components';
import { Footer, QuizHeader } from './components';
import { Empty, QuizResult } from '../../components';
import { QuizPlayground } from './components/QuizPlayground';
import type { FooterProps } from './components/Footer';
import type { CourseType, LessonType } from '../../api';
import type { QuizPlaygroundProps } from './components/QuizPlayground';
import type { EnrollmentType, CompleteQuizResult } from '../../api';

type QuizComponentProps = QuizPlaygroundProps &
  FooterProps & {
    jessica: React.ReactNode;

    loading: boolean;

    stepId: string;
    course: CourseType | null;
    courseStep: LessonType | null;
    quizResult?: CompleteQuizResult;
    enrollment: EnrollmentType | null;
  };

export const QuizComponent: React.FC<QuizComponentProps> = ({
  quiz,
  loading,

  course,
  stepId,
  enrollment,
  quizResult,
  courseStep,

  jessica,

  ...rest
}) => {
  const history = useHistory();
  const isMobile = useIsMobile();

  if (loading) return null;

  if (!quiz) return <Empty message="Quiz is not available" />;

  return (
    <div
      className={clsx(
        'flex border-t overflow-auto grow h-full',
        !!quizResult && 'justify-center'
      )}
    >
      <div className="grow relative w-full flex flex-col px-md lg:px-[5rem] max-w-[76.8rem] 2xl:mx-[17.8rem]">
        <QuizHeader title={`Quiz 1: ${courseStep?.title || 'Title'}`} />
        {quizResult ? (
          <>
            <QuizResult
              withReview
              result={quizResult}
              goToCourse={() =>
                history.push(
                  `/courses/${enrollment?.id}?step=${stepId}&track_finish=true`
                )
              }
            />
            {!!quizResult.passed && <FinishedModal result={quizResult} />}
            {jessica}
          </>
        ) : (
          <>
            <QuizPlayground {...rest} quiz={quiz} isMobile={isMobile} />
            <Footer {...rest} quiz={quiz} isMobile={isMobile} />
          </>
        )}
      </div>
    </div>
  );
};
